var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import {FieldType} from "../context/types";
export const selectAllValue = "selectAll";
export const sortCustomFieldsByRank = (fieldA, fieldB) => {
  if (fieldA.rank > fieldB.rank || fieldA.rank && !fieldB.rank) {
    return 1;
  } else if (fieldA.rank < fieldB.rank || !fieldA.rank && fieldB.rank) {
    return -1;
  }
  return 0;
};
export function transformCustomFields(fields) {
  const getValue2 = (field) => {
    var _a, _b, _c;
    if (!field.value || field.type == FieldType.label) {
      return void 0;
    }
    switch (field.type) {
      case FieldType.multiCheckbox:
      case FieldType.multiSelect:
        const res = (_a = field.value) == null ? void 0 : _a.split("&");
        if (((_b = field.context) == null ? void 0 : _b.select_all) && res.length === ((_c = field.context) == null ? void 0 : _c.options.length)) {
          res.unshift(selectAllValue);
        }
        return res;
      case FieldType.checkbox:
        return Boolean(field.value);
      default:
        return field.value;
    }
  };
  return fields.reduce((res, field) => __spreadProps(__spreadValues({}, res), {
    [field.name]: getValue2(field)
  }), {});
}
export const updateFieldWithSelectAll = ({
  values,
  field,
  allValues,
  updatedValues,
  newAllValues,
  form
}) => {
  var _a, _b;
  const newAllValuesCopy = __spreadValues({}, newAllValues);
  if (Object.values(values)[0].includes(selectAllValue) || ((_a = field.context) == null ? void 0 : _a.options.length) === Object.values(values)[0].length) {
    if (!allValues[field.name] || allValues[field.name].length < updatedValues[field.name].length) {
      newAllValuesCopy[field.name] = (_b = field.context) == null ? void 0 : _b.options.reduce((res, {value}) => [...res, value], [
        selectAllValue
      ]);
      form.setFieldsValue({
        [field.name]: newAllValuesCopy[field.name]
      });
    } else if (!Object.values(values)[0].includes(selectAllValue) && allValues[field.name].length === updatedValues[field.name].length + 1) {
      newAllValuesCopy[field.name] = [];
      form.setFieldsValue({
        [field.name]: newAllValuesCopy[field.name]
      });
    } else {
      newAllValuesCopy[field.name] = updatedValues[field.name].filter((value) => value !== selectAllValue);
      form.setFieldsValue({
        [field.name]: newAllValuesCopy[field.name]
      });
    }
  }
  return newAllValuesCopy;
};
const getValue = (key, field, values) => {
  var _a, _b;
  if (!values[key])
    return void 0;
  switch (field.type) {
    case FieldType.multiCheckbox:
    case FieldType.multiSelect:
      return ((_a = field.context) == null ? void 0 : _a.select_all) ? (_b = values[key]) == null ? void 0 : _b.filter((value) => value !== selectAllValue).join("&") : values[key].join("&");
    default:
      return values[key].toString();
  }
};
export const prepareCustomFields = (values, customFields) => {
  return Object.keys(values).reduce((custom, key) => {
    const field = customFields.find((field2) => field2.name === key);
    custom[field.id] = getValue(key, field, values);
    return custom;
  }, {});
};
export function prepareRequestData(customFields, values) {
  if (!customFields.length) {
    return {regular: values};
  }
  const regular = {};
  const custom = {};
  Object.keys(values).forEach((key) => {
    const field = customFields.find((field2) => field2.name === key);
    if (field) {
      custom[field.id] = getValue(key, field, values);
    } else {
      regular[key] = values[key];
    }
  });
  return {regular, custom};
}
